import React from "react";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router";
import {
  Proschool_logo,
  book_logo3,
  half_circle_bg_image,
  half_circle_bg_image2,
  terms_condition_image,
  terms_condition_image_title
} from "../../assets/images/images";
import HomeNavbar from "../home/components/HomeNavbar";
import Footer from "../home/components/Footer";
import useBranding from "../../hooks/useBranding";

const TermsAndConditionProschool = () => {
  const branding = useBranding();
  const appName = branding.productName;
  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const subadmin_details = globalState.subadmin_details;
  const handleClick = (e) => {
    e.preventDefault(); // Prevent default link behavior

    // Navigate to the home page
    navigate("/");

    // Use setTimeout to delay the scroll to the specific section
    setTimeout(() => {
      const element = document.getElementById("revolution_sec_new");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Adjust the timeout as needed
  };

  return (
    <>
      <HomeNavbar />
      <div className="Terms-and-Conditions-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="Terms-and-Conditions-wrapper">
                <div className="Terms-and-Conditions-image-title">
                  <img src={terms_condition_image_title} />
                </div>
                <div className="Terms-and-Conditions-image">
                  <img src={terms_condition_image} />
                </div>
                <div className="Terms-and-Conditions-list-wrapper">
              <div className="Terms-and-Conditions-list-foldre">
                <p>
                  These Terms of Use and Service ("Terms") explain how you may use the {appName} website, operated by Arcot AI Solutions Private Limited, platform, and related online services (together, the "Services"). By accessing or using the Services, you are deemed to have accepted these Terms and our Privacy Policy. If you do not agree, you should not use the Services.
                </p><br/>
                <p>
                  If you are a school, college, coaching centre, or other educational institution using {appName}, you are responsible for ensuring that your students, staff, and other users are aware of and comply with these Terms.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>1. About {appName}</h2>
                <p>
                  {appName} is a digital learning platform that provides curriculum-aligned and AI-generated content, courses, lesson plans, and assessments, AI-powered learning support, and communication tools for students, teachers, and educational institutions. (collectively referred to as "{appName}", "we", "us", or "our").
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>2. Who may use the Services</h2>
                <p>
                  The Services offered by {appName} are intended for use by educational institutions, including schools, colleges, independent coaching centres, tutoring centres, and other authorised learning organisations, as well as teachers, school administrators, students, and parents or legal guardians.
                </p><br/>
                <p>Where the Services are used by children or minors, their access is permitted only:</p>
                <ol>
                  <li>
                    <p>
                      under the supervision of a parent or legal guardian; or
                    </p>
                  </li><li>
                    <p>
                      under the authorization and oversight of a school or other educational institution.
                    </p>
                  </li>
                </ol><br/>
                <p>
                  Parents, guardians, and educational institutions are responsible for the supervision of minors using the Services and for ensuring that all use is lawful and appropriate.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>3. Accounts and security</h2>
                <p>
                  Certain features of the Services require creating a user account. You must provide accurate and up to date information, keep your login credentials confidential, and notify us promptly if you suspect any unauthorized use of your account.
                </p>
                <p>
                  We may suspend or disable an account if we reasonably believe it is being misused, compromised, or used in violation of these Terms or applicable law.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>4. How you may use the Services</h2>
                <p>You may use the Services only for lawful educational and related administrative purposes.</p><br/>

                <p>You must not:</p>
                <ol>
                  <li>
                    <p>
                      use the Services in any way that is unlawful, harmful, or misleading;
                    </p>
                  </li>
                  <li>
                    <p>
                      upload or share content that is abusive, hateful, defamatory, obscene, sexually explicit, or otherwise inappropriate, particularly in relation to children;
                    </p>
                  </li>
                  <li>
                    <p>
                      attempt to gain unauthorized access to any part of the Services, user accounts, or systems;
                    </p>
                  </li>
                  <li>
                    <p>
                      interfere with the operation or security of the Services;
                    </p>
                  </li>
                  <li>
                    <p>
                      attempt to copy, reverse engineer, or modify the underlying software of the Services, except where this is expressly allowed by law; or
                    </p>
                  </li>
                  <li>
                    <p>
                      misuse any AI or chatbot features to generate or distribute harmful, illegal, or prohibited content.
                    </p>
                  </li>
                </ol><br/>
                <p>
                  If you are an educational institution, you must ensure that your use of the Services and your instructions to us comply with all applicable education, child protection, and data protection laws.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>5. Terms of Use - Teachers and School Administrators</h2>
                <ol>
                  <li>
                    <strong>Acting on behalf of the School</strong>
                    <p>
                      By using {appName} as a teacher, staff member, or school administrator, you acknowledge that you are accessing and using the Services on behalf of your institution (the "Subscriber") and that your use is subject to that institution's internal policies in addition to these Terms.
                    </p>
                  </li>
                  <li>
                    <strong>Parental consent and school authority (COPPA, GDPR, etc.)</strong>
                    <p>You understand that, where applicable:</p>
                    <ul className="privacy-policy-list-for-external-Processing">
                      <li>
                        <span>
                          <p>
                            the Children's Online Privacy Protection Act (COPPA) (for schools in the United States),
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>
                            the General Data Protection Regulation (GDPR) (for schools in the EU/EEA and Switzerland),
                          </p>
                        </span>
                      </li>
                    </ul><br/>
                    <p>
                      require parental consent or an appropriate legal basis for the collection and processing of personal information of children and minors.
                    </p><br/>
                    <p>
                      For underage students covered by these laws, {appName} relies on the school's authorization and consent ("School Consent") where the school is permitted to provide such consent on behalf of parents/guardians or to establish an alternative lawful basis.
                    </p><br/>
                    <p>{appName} operates as:</p>
                    <ul className="privacy-policy-list-for-external-Processing">
                      <li>
                        <span>
                          <p>
                            a "school official" with a legitimate educational interest under FERPA (where applicable in the US); and
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>
                            a data processor under GDPR (and similar laws), acting on the instructions of the Subscriber as data controller.
                          </p>
                        </span>
                      </li>
                    </ul><br/>
                    <p>
                      If your school or you, as a teacher, wish to obtain direct parental consent, {appName} can provide a model consent form or template upon request.
                    </p>
                  </li>
                  <li>
                    <strong>Purpose of use</strong>
                    <p>
                      You agree to use the Services only for legitimate academic, pastoral, and school administrative purposes, and to take reasonable steps to ensure that students in your class also use the Services responsibly and in accordance with these Terms.
                    </p>
                  </li>
                  <li>
                    <strong>Respect for student and user privacy</strong>
                    <p>
                      You will treat all student and user information accessed through the Services as confidential. You will not disclose or share any student-generated content, personal information, or educational records with unauthorised persons or for purposes unrelated to education, except as required by law or explicitly allowed by the Subscriber.
                    </p>
                  </li>
                  <li>
                    <strong>Student enrolment</strong>
                    <p>
                      You will only create, invite, or maintain accounts for students who are currently enrolled in your class, grade, or institution and whose use of the Services has been approved by the Subscriber.
                    </p>
                  </li>
                  <li>
                    <strong>Rights in content you upload</strong>
                    <p>
                      You confirm that you hold, or have obtained, all rights, permissions, and licences necessary to use and upload any content you contribute (including text, images, audio, video, and other materials), and to permit {appName} to use such content as described in the Terms and in the Privacy Policy.
                    </p>
                  </li>
                  <li>
                    <strong>Educational Records (FERPA)</strong>
                    <p>
                      For schools in the United States, you confirm that your institution has obtained all authorisations and permissions required to share "education records" (as defined under FERPA) with {appName} for the purpose of delivering the Services as a school official.
                    </p>
                  </li>
                  <li>
                    <strong>Data Processing Agreement (GDPR)</strong>
                    <p>
                      For schools in the EU/EEA and Switzerland, you understand that the Subscriber is the data controller and {appName} is the data processor in relation to personal data processed through the Services. You acknowledge that your institution is responsible for ensuring a valid Data Processing Agreement (DPA) with {appName} that complies with GDPR requirements.
                    </p>
                  </li>
                </ol>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>6. Terms of Use for Students</h2>
                <ol>
                  <li>
                    <strong>Account creation</strong>
                    <p>
                      You may only access {appName} using the login methods provided or approved by your school, and you must not share your account credentials with anyone else. {appName} is not responsible for any unauthorised access or misuse of your account resulting from shared credentials, lack of supervision by the institution, or security issues within the institution's systems or networks.
                    </p>
                  </li>
                  <li>
                    <strong>Parental or guardian consent</strong>
                    <p>
                      You must have the consent of your parent or legal guardian to use the Services where required by law. In particular:
                    </p>
                    <ul className="privacy-policy-list-for-external-Processing">
                      <li>
                        <span>
                          <p>
                            if you are under 13 years of age in the United States, you must have parental or guardian consent;
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>
                            if you are under 18 years of age in India, you must have parental or guardian consent; and
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>
                            if local laws in your country set a different age for consent, that law will apply.
                          </p>
                        </span>
                      </li>
                    </ul>
                    <p>
                      {appName} (and/or your school) may deny or suspend access to the Services if appropriate consent cannot be obtained or verified.
                    </p>
                  </li>
                  <li>
                    <strong>Responsible use and respect for others</strong>
                    <p>
                      You agree to use the Services responsibly, follow your school's rules, and respect the rights and privacy of other users. You must not use {appName} to bully, harass, threaten, or harm anyone, or to share content that is offensive, illegal, or inappropriate. This includes, without limitation, any derogatory, abusive, or discriminatory remarks or content relating to a person's race, ethnicity, nationality, religion or belief, caste, gender, gender identity, sexual orientation, disability, or any other protected characteristic.
                    </p>
                  </li>
                  <li>
                    <strong>Sharing personal information</strong>
                    <p>
                      You should not publicly share your personal information (such as your full name, phone number, email address, home address, or personal photos/videos) in public areas of the platform unless your school and parent/guardian have approved such sharing and it is clearly required for your learning activity.
                    </p>
                  </li>
                  <li>
                    <strong>Educational Records and data</strong>
                    <p>
                      Where applicable (for example, under FERPA in the US), you acknowledge that {appName} may receive and store information that forms part of your educational records as used by your school. Such information is handled in line with our Privacy Policy and with the laws that apply to your institution.
                    </p>
                  </li>
                </ol>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>7. Terms of Use for Parents and Legal Guardians</h2>
                <ol>
                  <li>
                    <strong>Consent to use of the Services</strong>
                    <p>
                      By allowing your child or ward to use {appName}, you consent to their use of the Services and to {appName} processing their personal information as described in our Privacy Policy and in your school's policies.
                    </p>
                  </li>
                  <li>
                    <strong>Collection of personal information</strong>
                    <p>
                      You understand that {appName} may collect and process personally identifiable information about your child or ward (for example, name, contact details, class information, learning data, photos or videos where appropriate and approved by the school) in order to provide and improve the Services.
                    </p>
                  </li>
                  <li>
                    <strong>Children using the Services without consent</strong>
                    <p>
                      If your child or ward is under the legal age of consent (for example, under 13 in the USA or under 18 in India) and you believe they are using the Services without your permission or the school's proper authorisation, you should contact us promptly at support@proschool.ai with relevant details so that we can review and address the situation.
                    </p>
                  </li>
                  <li>
                    <strong>Communications</strong>
                    <p>
                      You understand and agree that {appName} and teachers or staff using the Services may send you communications (for example, messages, notifications, alerts, emails, or similar) relating to your child's or ward's learning and use of the platform, in line with the contact preferences you or your school have set.
                    </p>
                  </li>
                  <li>
                    <strong>Educational Records (FERPA)</strong>
                    <p>
                      Where FERPA or similar laws apply, you consent to {appName} storing and processing your child's education records on behalf of the school for educational and administrative purposes, subject to applicable legal protections and your rights as a parent or guardian.
                    </p>
                  </li>
                </ol>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>8. General Terms of Use for All Users</h2>
                <ol>
                  <li>
                    <strong>Compliance with law</strong>
                    <p>
                      You agree that you will not use the Services in any way that violates any applicable law, regulation, or governmental guideline, including child protection, education, and data protection laws.
                    </p>
                  </li>
                  <li>
                    <strong>Authorised users only</strong>
                    <p>
                      Only current teachers, staff, students, and parents/guardians of the Subscriber (school or institution) are permitted to access {appName} under that Subscriber's account. You must not give or enable access to {appName} to any person who is not authorised by the Subscriber or {appName}.
                    </p>
                  </li>
                  <li>
                    <strong>End of association with the school</strong>
                    <p>
                      If you are no longer associated with a Subscriber (for example, you leave the school as a teacher, staff member, or student), you agree to stop accessing {appName} using that school's credentials or any school-provided access codes.
                    </p>
                  </li>
                  <li>
                    <strong>No reverse engineering or misuse of technology</strong>
                    <p>
                      You must not attempt to copy, modify, decompile, reverse engineer, or obtain the source code of the platform or any part of the Services, except where this is permitted by law and then only after notifying us in writing.
                    </p>
                  </li>
                  <li>
                    <strong>Confidential information and intellectual property</strong>
                    <p>
                      You must not share, distribute, or provide unauthorised access to any documents, materials, or information containing {appName}'s confidential information or intellectual property, except as expressly allowed by us or by the Subscriber's agreement with us.
                    </p>
                  </li>
                  <li>
                    <strong>Permitted purpose -- non-commercial educational use</strong>
                    <p>
                      You agree to use the Services for personal, non-commercial, academic and school-related purposes only, unless you have a separate written agreement with {appName} permitting other uses.
                    </p>
                  </li>
                  <li>
                    <strong>Responsibility for your actions and content</strong>
                    <p>
                      You are responsible for all actions taken through your account and for any content you submit or access through the Services. Any fraudulent, abusive, or illegal activity may result in suspension or termination of your access and may be reported to the relevant authorities where required.
                    </p>
                  </li>
                  <li>
                    <strong>Prohibited behaviour and content</strong>
                    <p>You agree that you will not:</p>
                    <ul className="privacy-policy-list-for-external-Processing">
                      <li>
                        <span>
                          <p>
                            post or share content that infringes the intellectual property, privacy, or other rights of any person;
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>
                            upload or transmit content that is harmful, threatening, harassing, defamatory, vulgar, obscene, or otherwise objectionable;
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>
                            attempt to obtain login details, passwords, or sensitive information from other users;
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>
                            use automated tools (such as bots, spiders, or scrapers) to access or collect information from the Services without our written permission.
                          </p>
                        </span>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Service availability and changes</strong>
                    <p>
                      The Services are provided on an "as is" and "as available" basis. Access may occasionally be interrupted or limited due to maintenance, updates, technical issues, or factors outside our control. {appName} may modify, improve, suspend, or remove features or portions of the Services at its discretion. While we will take reasonable steps to provide notice of major changes where practical, we do not guarantee uninterrupted or error-free access.
                    </p>
                  </li>
                  <li>
                    <strong>Content from users and third parties</strong>
                    <p>
                      Some content available on {appName} may be created or provided by users or sourced from third parties. {appName} is not responsible for the accuracy, completeness, or legality of such content and is not liable for any loss or damage arising from your reliance on it. You should independently review and verify any such content before using it for important decisions, evaluations, or official academic purposes.
                    </p>
                  </li>
                  <li>
                    <strong>Links to other websites</strong>
                    <p>
                      From time to time, the Services may include links to websites or resources that are not operated by {appName}. These links are provided for convenience only and do not imply endorsement. We are not responsible for the content, availability, or practices of any third-party sites.
                    </p>
                  </li>
                </ol>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>9. Content and intellectual property</h2>
                <p>
                  All software, design, features, tools, and content made available by {appName} through the Services are owned by us or our licensors and are protected by intellectual property laws. You receive only a limited, non-exclusive, revocable permission to access and use the Services as described in these Terms.
                </p>
                <p>
                  You remain responsible for any material, including text, files, and other content, that you or your institution upload or submit to the Services. You must ensure that you have the right to use and share that content and that it does not infringe anyone's rights or break any law.
                </p>
                <p>
                  By submitting content to the Services, you allow {appName} to use, store, and process that content only as needed to operate, maintain, secure, and improve the Services and to support the educational activities of you or your institution, in line with our Privacy Policy.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>10. AI and Large Language Model (LLM) features</h2>
                <p>
                  {appName} uses artificial intelligence, including Large Language Models (LLMs), to provide features such as:
                </p>
                <ol>
                  <li>
                    <p>
                    help with generating lesson plans, questions, and assignments;
                    </p>
                  </li> 
                  <li>
                    <p>
                      explanations, summaries, and practice questions for students;
                    </p>
                  </li>
                  <li>
                    <p>
                      suggestions and recommendations for teachers and institutions; and
                    </p>
                  </li>
                  <li>
                    <p>
                      chatbot-based academic and general support.
                    </p>
                  </li>
                </ol><br/>
                <p>
                  AI-generated outputs may sometimes be incomplete, outdated, or not suitable for your specific context. They are intended as support tools only. Teachers, schools, and users must review and adapt any AI-generated material before using it in classes, examinations, or other formal academic activities.
                </p><br/>
                <p>
                  {appName} does not use children's or students' personal information to train generalized AI models. Any processing of personal data by AI systems is limited to providing and improving the Services under our control or under written agreements with AI providers acting as processors, and always in accordance with our Privacy Policy and applicable law.
                </p><br/>
                <p>
                  You must not attempt to use AI features to generate or request illegal, abusive, explicit, or otherwise prohibited content.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>11. Curriculum alignment and school boards</h2>
                <p>
                  {appName} is built to support curriculum-aligned learning. When an educational institution configures the platform and specifies the applicable curriculum or school board, {appName}:
                </p>
                <ol>
                  <li>
                    <p>
                      strictly follows the academic standards, syllabus requirements, and instructional guidelines prescribed by the relevant school board(s) identified by the institution; and
                    </p>
                  </li>
                  <li>
                    <p>
                      designs and generates educational content, including courses, lesson plans, and assignments, to align with those prescribed frameworks.
                    </p>
                  </li>
                </ol><br/>
                <p>
                  Our AI systems are tuned to reflect national, state, and international board guidelines as communicated by the institution. However, schools and teachers remain responsible for confirming that any content used in their classrooms, examinations, or official work is appropriate, accurate, and fully aligned with the exact requirements of the board and regulators that apply to them.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>12. Child protection and safe use</h2>
                <p>
                  {appName} is committed to protecting children and students using the Services and to supporting compliance with applicable child protection and education laws, including the Protection of Children from Sexual Offences Act, 2012 (POCSO), Indian and state education laws, and relevant guidelines and manuals issued by government bodies and child rights authorities.
                </p><br/>
                <p>
                  We do not permit any content or behaviour on the platform that exploits, abuses, or endangers children. This includes any sexually explicit, suggestive, or otherwise harmful material involving or targeting minors.
                </p><br/>
                <p>
                  Where we become aware of content or activity that may amount to an offence or a serious risk to a child, we may restrict access, suspend accounts, preserve relevant information, and cooperate with law enforcement or child protection authorities, as required by law.
                </p><br/>
                <p>
                  Institutions, teachers, parents, and guardians are expected to monitor and guide children's use of the Services and to report any concerning content or behaviour to us without delay.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>13. Privacy and data protection</h2>
                <p>
                  Our use of personal information is described in detail in the {appName} Privacy Policy, which is available on our website and forms an important part of these Terms.
                </p>
                <p>In summary:</p>
                <ol>
                  <li>
                    <p>
                      we collect and process personal information only as needed to provide and improve the Services and to support educational activities;
                    </p>
                  </li>
                  <li>
                    <p>
                      we comply with applicable data protection and education laws in the jurisdictions where we operate (including, as relevant, Indian IT and data protection laws, COPPA, PPRA, CIPA and FERPA in the United States, and other local rules);
                    </p>
                  </li>
                  <li>
                    <p>
                      we do not sell children's or students' personal information and do not use such information for behavioural advertising; and
                    </p>
                  </li>
                  <li>
                    <p>
                      where we act on behalf of an educational institution, we process personal information under that institution's instructions, as its processor or "school official", subject to applicable law.
                    </p>
                  </li>
                </ol><br/>
                <p>
                  You should read the Privacy Policy carefully to understand how data is collected, used, shared, and protected.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>14. Third-party tools and integrations</h2>
                <p>
                  {appName} uses certain third-party services to operate the platform. These may include:
                </p>
                <ol>
                  <li>
                    <p>
                      Google services, including Google Drive, to store and manage educational files and documents; and
                    </p>
                  </li>
                  <li>
                    <p>
                      AI and infrastructure providers who host or support our AI and LLM-based features.
                    </p>
                  </li>
                </ol><br/>
                <p>
                  Where these third parties process personal information on our behalf, they do so under contractual obligations to keep the data secure, confidential, and limited to the purposes we specify, in line with applicable laws and our Privacy Policy.
                </p><br/>
                <p>
                  Your use of integrated services such as Google may also be subject to the terms and privacy policies of those third parties.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>15. Availability, disclaimers, and limitation of liability</h2>
                <p>
                  We aim to provide a secure, reliable, and high-quality learning experience. However, the Services are provided on an "as is" and "as available" basis.
                </p><br/>
                <p>
                  Without limiting any rights you may have under mandatory law, {appName} does not promise that the Services will be uninterrupted, free of errors, or suitable for every particular purpose. AI-generated content, recommendations, and analytics are not a substitute for teacher judgment, institutional policies, or official curriculum material.
                </p><br/>
                <p>
                  To the extent permitted by law, {appName} is not responsible for any indirect or consequential loss, or loss of data, profits, or business, arising from your use of the Services. Where liability cannot be excluded, it will be limited to the extent permitted under applicable law.
                </p><br/>
                <p>
                  Nothing in these Terms affects rights or remedies that cannot be excluded or limited under applicable consumer, education, or data protection laws.
                </p><br/>
                <p>
                  {appName} is not responsible or liable for any misuse of the Services or any data accessed through the Services by teachers, administrators, staff, students, parents, or any other individuals associated with an educational institution or organisation. If any such person, acting on his or her own will and contrary to these Terms, institutional policies, or applicable law, misuses, extracts, discloses, or otherwise improperly handles data obtained from the Services, such conduct is solely the responsibility of that individual and/or the institution. To the fullest extent permitted by law, {appName} shall not be liable for any legal action, claim, loss, or consequence arising from such misuse.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>16. Changes to the Services and to these Terms</h2>
                <p>
                  We may update or change the Services from time to time, for example to add features, improve performance, enhance security, or comply with new legal requirements.
                </p><br/>
                <p>
                  We may also update these Terms. When we do, we will change the "Last updated" date at the top of this page and may provide additional notice where required by law. If you continue to use the Services after the Terms are updated, you will be treated as having accepted the updated Terms. If you do not agree with changes, you should stop using the Services.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>17. Governing law</h2>
                <p>
                  These Terms and your use of the Services are subject to the laws that apply in the jurisdiction where {appName} is established and operates, subject to any mandatory local laws that apply to you.
                </p><br/>
                <p>
                  For Indian operations, the Services and these Terms are generally governed by the laws of India. This is without limiting any non-waivable rights or protections available to users under the laws of the United States or other applicable jurisdictions.
                </p>
              </div>

              <div className="Terms-and-Conditions-list-foldre">
                <h2>18. Contact us</h2>
                <p>
                  If you have any questions about these Terms or the Services, or if you wish to raise a concern, you can contact us at:
                </p>
                <p>Email: {branding.infoEmail}</p><br/>
                <p>
                  We will review and respond within a reasonable time, taking into account the nature of your query and any applicable legal requirements.
                </p>
              </div>
            </div>
                <div className="half-circle-bg-image">
                  <img src={half_circle_bg_image} />
                </div>
                <div className="half-circle-bg-image2">
                  <img src={half_circle_bg_image2} />
                </div>
                <div className="book-logo3">
                  <img src={book_logo3} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
      {/* <div className="footer-section" id="footer-section">
        <div className="footer-wraper">
          <div className="footer-link-folder">
            <div className="proschool-logo">
              <img src={subadmin_details ? subadmin_details?.school_image : Proschool_logo} /> <span>Beta</span>
            </div>
          </div>
          <div className="footer-Quick-Links-folder">
            <h2>Quick Links</h2>
            <ul className="footer-Quick-Links">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <a href="revolution_sec_new" onClick={handleClick}>
                  Features
                </a>
              </li>
              <li>
                <NavLink to="/about">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/terms-and-conditions">Terms & Conditions</NavLink>
              </li>
              <li>
                <NavLink to="/privacy-policy">Privacy Policy</NavLink>
              </li>
            </ul>
          </div>
          <div className="footer-Quick-Links-folder">
            <h2>Contact</h2>
            <div className="footer-contact">
              <div className="footer-contact-folder">
                <a>
                  <i class="fa-solid fa-phone"></i>
                </a>
                <span>
                <a href="tel:+1 (646) 222-3901">{subadmin_details ? subadmin_details?.phone : '+1 (646) 222-3901'}</a>
                </span>
              </div>
              <div className="footer-contact-folder">
                <a>
                  <i class="fa-solid fa-envelope"></i>
                </a>
                {subadmin_details ? (
                    <a href={`mailto:${subadmin_details?.email}`}>{subadmin_details.email}</a>
                ) : (
                    <a href={`mailto:${branding.infoEmail}`}>{branding.infoEmail}</a>
                )}
                
                
              </div>
              <div className="footer-contact-folder">
                <a>
                  <i class="fa-solid fa-location-dot"></i>
                </a>
                {subadmin_details ? (
                  subadmin_details?.location
                ) : (
                  <a
                    href="https://www.google.com/maps/place/Arcitech+-+AI+Software,+Web,+App+Development/@19.0020445,72.8229651,16z/data=!4m10!1m2!2m1!1sA-802,+2nd+floor,+Trade+Link,+Kamala+Mills,+Lower+Parel,+Mumbai,+Maharashtra+400013!3m6!1s0x3be7ce9336955555:0x743645ef3c0b1a05!8m2!3d19.0033511!4d72.8274615!15sClNBLTgwMiwgMm5kIGZsb29yLCBUcmFkZSBMaW5rLCBLYW1hbGEgTWlsbHMsIExvd2VyIFBhcmVsLCBNdW1iYWksIE1haGFyYXNodHJhIDQwMDAxM1pPIk1hIDgwMiAybmQgZmxvb3IgdHJhZGUgbGluayBrYW1hbGEgbWlsbHMgbG93ZXIgcGFyZWwgbXVtYmFpIG1haGFyYXNodHJhIDQwMDAxM5IBEHNvZnR3YXJlX2NvbXBhbnmaASNDaFpEU1VoTk1HOW5TMFZKUTBGblNVTkxiMHBEVm1ObkVBReABAA!16s%2Fg%2F11lt56gqrs?entry=ttu"
                    target="_blank"
                  >
                    A-802, 2nd floor, Trade Link, Kamala Mills, Lower Parel,
                    Mumbai, Maharashtra 400013
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className="footer-get-in-touch-folder">
            <span>Get in touch</span>
            <div className="footer-social-link-folder">
              <a href={branding.social?.facebook || "#"} target="_blank">
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a href="https://twitter.com/Proschoolai" target="_blank">
                <i class="fa-brands fa-x-twitter"></i>
              </a>
              <a href={branding.social?.instagram || "#"} target="_blank">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a
                href={branding.social?.linkedin || "#"}
                target="_blank"
              >
                <i class="fa-brands fa-linkedin"></i>
              </a>
              <a href={branding.social?.youtube || "#"} target="_blank">
                <i class="fa-brands fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default TermsAndConditionProschool;
